import { Alert, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import axiosInstance from 'custom-axios';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import React, { useEffect, useState } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { useParams } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import { externalInvestmentOptions } from 'store/constant';

const FinancialInformation = ({ activeStep, setActiveStep }) => {

	const [loader, showLoader, hideLoader] = useFullPageLoader();
	const { id } = useParams();
	let userGetId = localStorage.getItem('user_get_id')
	const userId = id ? id : userGetId;
	const [dialogOpen, setDialogOpen] = useState({
		external_investment: false,
	});


	const { control, handleSubmit, setValue, formState: { errors } } = useFormContext();

	const sInvestingAccount = useWatch({ control, name: 's_investing_account' });
	const enlAssets = useWatch({ control, name: 'enl_assets' });
	const enfAssets = useWatch({ control, name: 'enf_assets' });
	const annualIncome = useWatch({ control, name: 'annual_income' });
	const sAnnualIncome = useWatch({ control, name: 's_annual_income' });
	const pFirstName = useWatch({ control, name: 'p_first_name' });
	const sFirstName = useWatch({ control, name: 's_first_name' });


	const handleClickExternalInvestmentOpen = () => {
		setDialogOpen({
			...dialogOpen,
			external_investment: true
		})
	};

	const handleClickExternalInvestmentClose = () => {
		setDialogOpen({
			...dialogOpen,
			external_investment: false
		})
	};

	const ExternalInvestmentDialogComponent = () => {
		return (
			<>
				<Dialog
					// fullScreen={matchesMD}
					open={dialogOpen.external_investment}
					onClose={handleClickExternalInvestmentClose}
					scroll='paper'
					aria-labelledby="responsive-dialog-title"
				>
					<DialogTitle id="responsive-dialog-title" className='font12px'>
						External Investment
					</DialogTitle>
					<DialogContent dividers={true}>
						<DialogContentText>

							<Typography paragraph>
								<Typography paragraph>
									<strong className='color-545151'>Equities: </strong>
									are investments in shares issued by publicly trade or private companies. These may include mutual funds, segregated funds, or private funds.
								</Typography>
							</Typography>

							<Typography paragraph>
								<strong className='color-545151'>Fixed Income : </strong>
								is an investment in debt securities that pay a rate of return in the form of interest.
							</Typography>

							<Typography paragraph>
								<strong className='color-545151'>Cash & Equivalents : </strong>
								include highly liquid investments such as MMFs (money market funds) and treasury bills.
							</Typography>
							<Typography paragraph>
								<strong className='color-545151'>Real Estate : </strong>
								is an investment in property outside your primary residence and other personal properties. This includes private real estate investments like  REITs(Real Estate investment Trusts) and other real estate funds.
							</Typography>
							<Typography paragraph>
								<strong className='color-545151'>Commodities : </strong>
								includes future contracts, options, and derivate.
							</Typography>
						</DialogContentText>
					</DialogContent>
				</Dialog>
			</>
		)
	}

	/* const changeFinancialInfo = (name, value) => {
		setFormData({ ...formData, [name]: value })
	}; */

	/* const handleChange = (name, value) => {
		setFormData(prevState => ({
			...prevState,
			[name]: value
		}));
	}; */

	/* const sumWar = () => {
		if (formData.enl_assets == 'NaN' || formData.enl_assets == '') {
			formData.enl_assets = null
		}

		if (formData.enf_assets == 'NaN' || formData.enf_assets == '') {
			formData.enf_assets = null
		}

		if (formData.annual_income == 'NaN' || formData.annual_income == '') {
			formData.annual_income = null
		}


		if (formData.s_annual_income == 'NaN' || formData.s_annual_income == '') {
			formData.s_annual_income = null
		}

		let enlAssets = formData.enl_assets ? parseFloat(formData.enl_assets) : 0;
		let enfAssets = formData.enf_assets ? parseFloat(formData.enf_assets) : 0;
		let annualIncome = formData.annual_income ? parseFloat(formData.annual_income) : 0;
		let sAnnualIncome = formData.s_annual_income ? parseFloat(formData.s_annual_income) : 0;

		let totalNetWorth = enlAssets + enfAssets + annualIncome + sAnnualIncome;

		setFormData({ ...formData, total_net_worth: Number(totalNetWorth.toFixed(2)) })
	} */


	/* const sumWar = () => {
		const values = getValues();

		const parseField = (field) => {
			if (values[field] === 'NaN' || values[field] === '') {
				return 0;
			}
			return parseFloat(values[field]) || 0;
		};

		const enlAssets = parseField('enl_assets');
		const enfAssets = parseField('enf_assets');
		const annualIncome = parseField('annual_income');
		const sAnnualIncome = parseField('s_annual_income');

		const totalNetWorth = enlAssets + enfAssets + annualIncome + sAnnualIncome;

		setValue('total_net_worth', Number(totalNetWorth.toFixed(2)), { shouldValidate: true });
	};
 */
	const handleRoleBack = async () => {
		showLoader();

		let endPoint = `api/change-form-step`;

		const submitData = { user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep - 1 }

		try {
			const response = await axiosInstance.post(endPoint, submitData);

			if (response.status === 200) {
				setActiveStep(activeStep - 1);
			}

		} catch (error) {
			// console.error(error)
			toast.error('An error occurred when navigating back.')
		} finally {
			hideLoader()
		}
	};

	const submitPersonalInfo = async (data) => {
		showLoader();

		let endPoint = `api/save-user-financial-info`;

		const cleanedData = {
			...data,
			enl_assets: parseVal(data.enl_assets),
			enf_assets: parseVal(data.enf_assets),
			annual_income: parseVal(data.annual_income),
			s_annual_income: parseVal(data.s_annual_income),
			total_net_worth: parseVal(data.total_net_worth),
			eq_non_reg: parseVal(data.eq_non_reg),
			eq_reg: parseVal(data.eq_reg),
			fi_non_reg: parseVal(data.fi_non_reg),
			fi_reg: parseVal(data.fi_reg),
			ce_non_reg: parseVal(data.ce_non_reg),
			ce_reg: parseVal(data.ce_reg),
			re_non_reg: parseVal(data.re_non_reg),
			re_reg: parseVal(data.re_reg),
			c_non_reg: parseVal(data.c_non_reg),
			c_reg: parseVal(data.c_reg),
		};

		const submitData = { ...cleanedData, user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep + 1 }

		// console.log(submitData)
		try {
			const response = await axiosInstance.post(endPoint, submitData);

			if (response.status === 200) {
				setActiveStep(activeStep + 1);
			}

		} catch (error) {
			// console.error(error)
			toast.error('An error occurred while submitting financial information.')

		} finally {
			hideLoader()
		}
	}

	const parseVal = (val) => {
		if (!val) return 0;
		const cleaned = val.toString().replace(/[$,]/g, '');
		const parsed = parseFloat(cleaned);
		return isNaN(parsed) ? 0 : parsed;
	};

	useEffect(() => {
		const total =
			parseVal(enlAssets) +
			parseVal(enfAssets) +
			parseVal(annualIncome) +
			(sInvestingAccount == 1 ? parseVal(sAnnualIncome) : 0);

		setValue('total_net_worth', Number(total.toFixed(2)));

	}, [enlAssets, enfAssets, annualIncome, sAnnualIncome, sInvestingAccount, setValue]);

	const renderCurrencyField = (name, label) => (
		<Controller
			name={name}
			control={control}
			render={({ field }) => (
				<NumberFormat
					{...field}
					customInput={TextField}
					prefix="$"
					allowNegative={false}
					label={label}
					thousandSeparator
					variant="outlined"
					size="small"
					fullWidth
					value={field.value || ''}
					onValueChange={({ floatValue }) => field.onChange(floatValue ?? '')}
					error={Boolean(errors?.[name])}
				/>
			)}
		/>
	);

	return (
		<>

			<form onSubmit={handleSubmit(submitPersonalInfo)}>
				<Grid container spacing={2} className='p-4'>

					<Grid item xs={12} className='mb-4'>
						<Typography variant='h3' className='form-head-gray-title'> {pFirstName ? pFirstName : 'Person'}'s Financial Profile</Typography>

					</Grid>

					<Grid item xs={5} className='text-right align-content-center'>
						<label htmlFor="enl-assets" className='font15px'>Estimated Net Liquid Assets (Value must be expressed in CAD) </label>
					</Grid>

					<Grid item xs={6}>
						{renderCurrencyField('enl_assets', 'Estimated Net Liquid Assets')}
					</Grid>
					<Grid item xs={1}></Grid>

					<Grid item xs={5} className='text-right align-content-center'>
						<label htmlFor="enf-assets" className='font15px'>Estimated Net Fixed Assets (Value must be expressed in CAD)</label>
					</Grid>

					<Grid item xs={6}>
						{renderCurrencyField('enf_assets', 'Estimated Non-Liquid Assets')}
					</Grid>
					<Grid item xs={1}></Grid>

					<Grid item xs={5} className='text-right align-content-center'>
						<label htmlFor="annual-income" className='font15px'>Account holders annual income from all sources (Value must be expressed in CAD) </label>
					</Grid>

					<Grid item xs={6}>
						{renderCurrencyField('annual_income', 'Annual Income')}
					</Grid>
					<Grid item xs={1}></Grid>

					{sInvestingAccount == 1 &&
						<>
							<Grid item xs={5} className='text-right align-content-center'>
								<label htmlFor="s-annual-income" className='font15px'> {sFirstName || 'Spouse'}'s account holders annual income from all sources (Value must be expressed in CAD) </label>
							</Grid>

							<Grid item xs={6}>
								{renderCurrencyField('s_annual_income', "Spouse's Annual Income")}
							</Grid>
							<Grid item xs={1}></Grid>
						</>
					}


					<Grid item xs={5} className='text-right align-content-center'>
						<label htmlFor="annual-income" className='font15px'>Estimated Total Net Worth </label>
					</Grid>

					<Grid item xs={6}>
						<Controller
							name="total_net_worth"
							control={control}
							render={({ field }) => (
								<NumberFormat
									{...field}
									customInput={TextField}
									prefix="$"
									allowNegative={false}
									label="Estimated Total Net Worth"
									thousandSeparator
									variant="outlined"
									size="small"
									fullWidth
									disabled
									value={field.value || ''}
									onValueChange={({ floatValue }) => field.onChange(floatValue ?? '')}
								/>
							)}
						/>

					</Grid>
					<Grid item xs={1}></Grid>

					<Grid item xs={12}>
						<Typography variant='h3' className='form-head-gray-title'>External Investments</Typography>
					</Grid>

					<Grid item xs={12}>
						<Alert
							severity='info'
							className='font14px cursor-pointer'
							onClick={handleClickExternalInvestmentOpen}
						>
							Click here for more information about External Investment.
						</Alert>
					</Grid>


					<Grid item xs={4} className='text-right'> <label className='font15px font-weight500px'>Asset Category</label></Grid>
					<Grid item xs={4}> <label className='font15px font-weight500px'>Non-Registered</label></Grid>
					<Grid item xs={4}> <label className='font15px font-weight500px'>Registered</label></Grid>

					{externalInvestmentOptions.map(option => (
						<React.Fragment key={option.label}>
							<Grid item xs={4} className="text-right align-content-center">
								<label className="font15px">{option.label}</label>
							</Grid>

							{option.fields.map(fieldName => (
								<Grid item xs={4} key={fieldName}>
									<Controller
										name={fieldName}
										control={control}
										render={({ field }) => (
											<NumberFormat
												{...field}
												customInput={TextField}
												prefix="$"
												allowNegative={false}
												thousandSeparator
												variant="outlined"
												size="small"
												fullWidth
												value={field.value || ''}
												onValueChange={({ floatValue }) => field.onChange(floatValue ?? '')}

											/>
										)}
									/>
								</Grid>
							))}
						</React.Fragment>
					))}

				</Grid>


				<Grid item xs={12} sm={6} className='pt-3 text-center'>
					<Button variant='outlined' className='m-3' onClick={handleRoleBack}>
						Back
					</Button>
					<Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
						Next
					</Button>
				</Grid>
			</form>
			<ExternalInvestmentDialogComponent />
			{loader}
			<ToastContainer />
		</>
	)
}

export default FinancialInformation